import i18n from '.';

/* Données venues de la base qui portent leur traduction anglaise à côté du français
   (`libelle` / `libelleEn`, posés par migration). Un écran affiche celle de
   l'interface, un document celle de son destinataire (`langue`). Sans traduction :
   le français, c'est-à-dire l'affichage d'avant. */

/** Le libellé dans la langue demandée (celle de l'interface par défaut). */
export const libelleTraduit = (fr, en, langue = i18n.language) => (langue === 'en' && en ? en : fr);

/** Libellé d'un délai porté par une notification ou une pénalité. */
export const libelleDelai = (n, langue) => libelleTraduit(n?.libelleDelai, n?.libelleDelaiEn, langue);
